import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddLearningOutcomeMutation,useGetCourseListQuery} from "../../../Services/api";

export default function Create() {
    const notify = () => '';
   
    const { register, handleSubmit, formState: { errors }} = useForm();
    const [addLearningOutcome,isLoading] = useAddLearningOutcomeMutation();
   
    const onSubmit = (values,e) => {
    
        const formData = new FormData();
        formData.append('course_id', values.course_id);
        formData.append('element_name', values.element_name);
        formData.append('element_tag', values.element_tag);
        formData.append('file', values.file[0]);
        formData.append('type', 'relevant_question');
        formData.append('introduction', values.introduction);
        
        addLearningOutcome( formData)
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    const {   
        data: getCourseList        
    } = useGetCourseListQuery({  params:''});
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Learning Outcome</h5>
                        <form onSubmit={handleSubmit(onSubmit)} >
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Course</label>
                                <div className="col-sm-10">
                                <select  {...register("course_id", { required: true })} className="form-control">
                                    <option value="">Select Course</option>                                           
                                    {                            
                                    getCourseList?.data?.map((item) => {
                                        return (
                                            <option key={item.course_id} value={item.course_id}>{item.course_name}</option>                                           
                                            )
                                        })
                                    }
                                    </select>
                                    {errors.course_id && <span  className="text-danger">Course is required</span>}
                            
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element Name</label>
                                <div className="col-sm-10">
                                    <input type="name" {...register("element_name" ,{ required: true})} className="form-control" />
                                    {errors.element_name && <span  className="text-danger">Element Name is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Element Tag</label>
                                <div className="col-sm-10">
                                    <input type="name" {...register("element_tag" ,{ required: true})} className="form-control" />
                                    {errors.element_tag && <span  className="text-danger">Element Tag is required</span>}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Relevant Questions</label>
                                <div className="col-sm-10">
                                    <input type="file" {...register('file' ,{ required: true })} className="form-control" />
                                    {errors.file && <span  className="text-danger">Relevant is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Introduction</label>
                                <div className="col-sm-10">
                                    <textarea rows={6} {...register("introduction" ,{ required: true})} className="form-control" >
                                    </textarea>
                                    {errors.introduction && <span  className="text-danger">Introduction is required</span>}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label"></label>
                                <div className="col-sm-10">
                                  {isLoading.status !='pending' ? 
                                                
                                    <button type="submit" className="btn btn-warning w-100" >Add Outcome</button>
                                    :
                                    <button  className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}